// Este archivo permite cambiar la URL de la API Backend en todo el soporte frontend.

const BASE_URL = 'https://holdedapi.agenciaadhoc.com';
// const BASE_URL = 'http://localhost:5200';
export default BASE_URL;